import { COGNITO_API } from 'src/config';
import { CognitoUser, CognitoUserPool, CognitoUserSession } from "amazon-cognito-identity-js";

export const UserPool = new CognitoUserPool({
    UserPoolId: COGNITO_API.userPoolId || '',
    ClientId: COGNITO_API.clientId || '',
});

const getSessionFromUser = (cognitoUser: CognitoUser): Promise<CognitoUserSession> => {
    return new Promise((resolve, reject) => {
        cognitoUser.getSession((err: null, session: CognitoUserSession) => {
            resolve(session)
            reject(err)
        })
    })
}

export const getAuthToken = async () => {
    const cognitoUser = UserPool.getCurrentUser();
    if (cognitoUser) {
        const session = await getSessionFromUser(cognitoUser)
        if (session) {
            return session.getAccessToken().getJwtToken();
        }
    }
}

